module.exports = __webpack_public_path__ + "static/img/advert_2_3.cebf1e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/advert_2_3.png
// module id = 76gq
// module chunks = 10